// extracted by mini-css-extract-plugin
export default {"core-exclusive":"_1Ct21","coreExclusive":"_1Ct21","cta":"_3EfyH"};